module.exports = __webpack_public_path__ + "static/media/green-plus.4136d020.png";